/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgCalendar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.79996 0C5.37434 0 5.83996 0.465624 5.83996 1.04V1.60016H10.16V1.04C10.16 0.465624 10.6256 0 11.2 0C11.7743 0 12.24 0.465624 12.24 1.04V1.68349C14.3818 2.09465 16 3.97842 16 6.24016V11.3602C16 13.9228 13.9226 16.0002 11.36 16.0002H4.64C2.0774 16.0002 0 13.9228 0 11.3602V6.24016C0 3.97845 1.61819 2.09469 3.75996 1.6835V1.04C3.75996 0.465624 4.22558 0 4.79996 0ZM3.75996 3.83543C2.77964 4.1943 2.08 5.13552 2.08 6.24016V11.3602C2.08 12.774 3.22615 13.9202 4.64 13.9202H11.36C12.7738 13.9202 13.92 12.774 13.92 11.3602V6.24016C13.92 5.13549 13.2203 4.19425 12.24 3.8354V4.64C12.24 5.21438 11.7743 5.68 11.2 5.68C10.6256 5.68 10.16 5.21438 10.16 4.64V3.68016H5.83996V4.64C5.83996 5.21438 5.37434 5.68 4.79996 5.68C4.22558 5.68 3.75996 5.21438 3.75996 4.64V3.83543ZM9.35996 10.4002C9.35996 9.82578 9.82559 9.36016 10.4 9.36016H10.48C11.0543 9.36016 11.52 9.82578 11.52 10.4002C11.52 10.9745 11.0543 11.4402 10.48 11.4402H10.4C9.82559 11.4402 9.35996 10.9745 9.35996 10.4002Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgCalendar
